export default __webpack_public_path__ + "static/start-5d3f9da15ec4d9abcce79462ff8bf79f.png";